import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import classnames from "classnames";
import styles from "./styles.module.scss";
import DoneGreenIcon from "../Icons/DoneGreen";
import CvParsingIcon from "../Icons/CvParsingIcon";
export interface CVCompositionPropsType {
  className?: React.HTMLAttributes<never>["className"];
  animate: boolean;
}
export interface AdditionalComponentPropsType {
  animate: boolean;
}
function Circle(t0) {
  const $ = _c(4);
  const {
    animate
  } = t0;
  let t1;
  if ($[0] !== animate) {
    t1 = classnames(styles.circle, {
      [styles.rotate]: animate
    });
    $[0] = animate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const circleClass = t1;
  let t2;
  if ($[2] !== circleClass) {
    t2 = <svg className={styles.circleSvg}><circle className={circleClass} cx="50" cy="50" r="48.5" /></svg>;
    $[2] = circleClass;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function PopUp(t0) {
  const $ = _c(4);
  const {
    animate
  } = t0;
  let t1;
  if ($[0] !== animate) {
    t1 = classnames(styles.doneIcon, {
      [styles.popOut]: animate
    });
    $[0] = animate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconClass = t1;
  let t2;
  if ($[2] !== iconClass) {
    t2 = <DoneGreenIcon className={iconClass} />;
    $[2] = iconClass;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function CVComposition(t0) {
  const $ = _c(11);
  const {
    className,
    animate
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classnames(styles.cvCompositionContainer, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const wrapperClassName = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== animate) {
    t2 = <CvParsingIcon animate={animate} />;
    t3 = <Circle animate={animate} />;
    t4 = <PopUp animate={animate} />;
    $[2] = animate;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== wrapperClassName) {
    t5 = <div className={wrapperClassName}>{t2}{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = wrapperClassName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export default CVComposition;